import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {gsap} from "gsap";
import {BruteForce} from "../BruteForce";
import {BruteForceGameMode} from "../server/BruteForceGameMode";

export class BruteForceXNudgeMultiFlyPresentation implements SimplePresentation {
    name: string = "SFSXNFlyingMultiPresentation";
    private _tl: gsap.core.Timeline;

    shouldRun(): boolean {
        return BruteForce.model.gameData.mode === BruteForceGameMode.FREESPIN_SUPER;
    }

    start(controller: SimplePresentationRunnerController): void {
        this._tl = gsap.timeline();
        this._tl.add(() => controller.setSkipCallback(() => {
            this._tl.timeScale(2);
        }));

        const isXNPartOfWinLine: boolean[] = [false, false, false, false, false];
        isXNPartOfWinLine.forEach((value: boolean, index: number) => {
            if (BruteForce.model.gameData.betLineWins.length > 0) {
                BruteForce.model.allWinPositions[index].forEach((value: boolean, symId: number) => {
                    if (value) {
                        if (BruteForce.model.gameData.evaluatedArea[index][symId] === "XN") {
                            isXNPartOfWinLine[index] = true;
                        }
                    }
                });
            }
        });

    /*    isXNPartOfWinLine.forEach((value: boolean, reelId: number) => {
            if (isXNPartOfWinLine[reelId] && !NudgeMeterMultiplierRetentionCases.isXNOnReelRetained(reelId)) {
                const additionTL: gsap.core.Timeline = gsap.timeline();
                const xNudgeSym: BruteForceXNudgeSymbol = <BruteForceXNudgeSymbol>BruteForce.allreelsView.reelModels[reelId].getStopSymbolAt(BruteForce.allreelsView.reelModels[reelId].reelView.nudgeReelPos);
                additionTL.add(BruteForce.gameContainer.getNudgeMultiplierFlying(xNudgeSym.typeOfNudge, reelId, BruteForce.model.gameData.xNudgeMultipliers[reelId]));
                additionTL.add(() => {
                    BruteForce.gameContainer.changeMultiplier(BruteForce.model.gameData.xNudgeMultipliers[reelId], true);
                }, ">");
                this._tl.add(additionTL);
            }
        });*/


        this._tl.add(() => {
            controller.setSkipCallback();
            controller.finish();
        });

    }

}